import { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

const PriceDefinition = ({ list }) => {
  const [showPrices, setShowPrices] = useState(false);

  // Sometimes the list can be undefined or an array with a single empty string
  const validItems = list?.filter(Boolean);

  if (isEmpty(validItems)) {
    return null;
  }

  return (
    <Accordion>
      <Accordion.Item className="border-0" eventKey="0">
        <Accordion.Header onClick={() => setShowPrices(!showPrices)}>
          <i
            className={`fas me-2 ${
              showPrices ? 'fa-chevron-up' : 'fa-chevron-down'
            }`}
          />
          <div className="reset-text">
            {showPrices ? 'Hide prices' : 'Show Prices'}
          </div>
        </Accordion.Header>
        <Accordion.Body className="pt-4">
          <ul>
            {validItems.map((item) => (
              <li key={item}>
                <p className="reset-text">{item}</p>
              </li>
            ))}
          </ul>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

PriceDefinition.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string),
};

export default PriceDefinition;
